import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Title2,
  Caption1,
} from '@fluentui/react-components';
import { Status } from '@bingads-webui-campaign-react/status-popover';

import { ActionCards, StatusSection } from './components/index';
import { useStyles } from './styles/diagnostic-card-styles';

export function DiagnosticCard({
  campaignStatusTitle,
  campaignStatusMsg,
  details,
  i18n,
  responsiveSize,
}) {
  const detailsToFix = details.filter(item => item.status !== Status.Active && item.cardTitle && (item.onCardButtonClicked || item.learnMoreLink));
  const classes = useStyles();

  return (
    <div className={classNames('ba-diagnostic-card')}>
      <Title2 className={classNames('ba-diagnostic-campaign-title', classes.campaignTitle)} block>{campaignStatusTitle}</Title2>
      <Caption1 className={classNames('ba-diagnostic-campaign-message', classes.campaignMsg)} block>{campaignStatusMsg}</Caption1>
      <StatusSection i18n={i18n} details={details} />
      {detailsToFix.length > 0 && <ActionCards details={detailsToFix} i18n={i18n} isSmallScreen={responsiveSize === 's'} />}
    </div>
  );
}

DiagnosticCard.propTypes = {
  campaignStatusTitle: PropTypes.string.isRequired,
  campaignStatusMsg: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(Status)).isRequired,
    statusLabelMsg: PropTypes.string.isRequired,
    cardTitle: PropTypes.string,
    cardMsg: PropTypes.string,
    onCardButtonClicked: PropTypes.func,
    cardButtonText: PropTypes.string,
  })).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  responsiveSize: PropTypes.string.isRequired,
};
